export default {
	components: {
		Alerts: () => import('./components/alerts'),
		UploadAlerts: () => import('./components/uploadAlerts'),
	},
	notify: function (type, title, message, duration) {
		Event.$emit('notifications:show', { type, title, message, duration });
	},
};
